

import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Search, Star, Store, Users } from "lucide-react";

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main className="bg-[#fafbff]">
        {/* Header */}
        <section className="border-b border-[#e5e7eb] bg-white">
          <div className="mx-auto max-w-[1200px] px-5 py-14 sm:px-6 lg:px-8 lg:py-16">
            <div className="max-w-[720px]">
              <p className="mb-3 text-[14px] font-bold uppercase tracking-[0.08em] text-[#0758b5]">
                About Us
              </p>

              <h1 className="text-[38px] font-extrabold leading-[1.15] tracking-[-1px] text-[#10203b] sm:text-[44px]">
                About BizNep
              </h1>

              <p className="mt-4 text-[17px] leading-[1.65] text-[#64748b]">
                Discover, connect with, and support local Nepali businesses
                through one simple platform.
              </p>
            </div>
          </div>
        </section>

        {/* About Content */}
        <section className="py-12 sm:py-14 lg:py-16">
          <div className="mx-auto max-w-[1200px] px-5 sm:px-6 lg:px-8">

            {/* Intro */}
            <div className="rounded-[18px] bg-white p-7 sm:p-9">
              <h2 className="text-[28px] font-extrabold text-[#10203b]">
                What is BizNep?
              </h2>

              <p className="mt-4 max-w-[850px] text-[16px] leading-[1.7] text-[#50627d]">
                BizNep is a platform created to make it easier for people to
                discover local Nepali businesses, services, and communities.
                We bring useful business information together in one place so
                users can find and connect with businesses more easily.
              </p>
            </div>

            {/* What We Offer */}
            <div className="mt-8">
              <h2 className="text-[28px] font-extrabold text-[#10203b]">
                What You Can Do
              </h2>

              <div className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">

                <div className="rounded-[14px] border border-[#e1e7ee] bg-white p-6">
                  <Search size={24} className="text-[#0758b5]" />
                  <h3 className="mt-4 text-[17px] font-bold text-[#10203b]">
                    Discover Businesses
                  </h3>
                  <p className="mt-2 text-[14px] leading-[1.6] text-[#64748b]">
                    Find local businesses, shops, restaurants, and services.
                  </p>
                </div>

                <div className="rounded-[14px] border border-[#e1e7ee] bg-white p-6">
                  <Star size={24} className="text-[#0758b5]" />
                  <h3 className="mt-4 text-[17px] font-bold text-[#10203b]">
                    Share Reviews
                  </h3>
                  <p className="mt-2 text-[14px] leading-[1.6] text-[#64748b]">
                    Share your experiences and help others discover great
                    businesses.
                  </p>
                </div>

                <div className="rounded-[14px] border border-[#e1e7ee] bg-white p-6">
                  <Store size={24} className="text-[#0758b5]" />
                  <h3 className="mt-4 text-[17px] font-bold text-[#10203b]">
                    For Businesses
                  </h3>
                  <p className="mt-2 text-[14px] leading-[1.6] text-[#64748b]">
                    Help businesses showcase their services and connect with
                    customers.
                  </p>
                </div>

                <div className="rounded-[14px] border border-[#e1e7ee] bg-white p-6">
                  <Users size={24} className="text-[#0758b5]" />
                  <h3 className="mt-4 text-[17px] font-bold text-[#10203b]">
                    Support Local
                  </h3>
                  <p className="mt-2 text-[14px] leading-[1.6] text-[#64748b]">
                    Connect people with local businesses and communities.
                  </p>
                </div>

              </div>
            </div>

            {/* Mission */}
            <div className="mt-8 rounded-[18px] bg-[#eef7ff] p-7 sm:p-9">
              <h2 className="text-[26px] font-extrabold text-[#10203b]">
                Our Mission
              </h2>

              <p className="mt-3 max-w-[850px] text-[16px] leading-[1.7] text-[#50627d]">
                Our mission is to help local Nepali businesses grow by
                connecting them with customers and giving communities a simple
                way to discover and support local businesses.
              </p>
            </div>

          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
